module.exports = __webpack_public_path__ + "img/qtrust.a156456b.png";